import { loadRecordSnapshot } from "../../../../collaboration/loadRecordSnapshot";
import { RecordCollaborationPanel } from "../../../../collaboration/RecordCollaborationPanel";
import toast from "react-hot-toast";
import { ReportAgreement } from "../../../../components/dashboard/service/reports/report-agreement";
import { useDispatch } from "react-redux";
import { useEffect, useMemo, useCallback, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { ServiceReportOperationObjectStatus, getChecklistStatus } from "../../../../components/dashboard/service/reports/utils";
import { fetchReport, fetchReportChecklist } from "../../../../api/service/report";
import { ResourceLoading } from "../../../../components/utils/ResourceLoading";
import { ResourceError } from "../../../../components/utils/ResourceError";
import { ResourceEmpty } from "../../../../components/utils/ResourceEmpty";
import {
  FullReportAddress,
  FullReportTitle,
} from "../../../../components/dashboard/service/reports/utils";
import DashboardHeader from "../../../../components/dashboard/dashboardHeader";
import {
  ArrowPathRoundedSquareIcon,
  AtSymbolIcon,
  BuildingOfficeIcon,
  ClipboardDocumentCheckIcon,
  ClipboardDocumentListIcon,
  MapPinIcon,
  PrinterIcon,
  UsersIcon,
  WrenchIcon,
  PhoneIcon,
  WrenchScrewdriverIcon,
  UserIcon,
  CubeIcon,
  VariableIcon,
  ClipboardDocumentIcon,
  CalculatorIcon,
  ClockIcon,
  SparklesIcon,
  RectangleGroupIcon,
} from "@heroicons/react/24/outline";
import { ReportResetDialog } from "../../../../components/dashboard/service/reports/report-reset-dialog";
import { ReportOrderDialog } from "../../../../components/dashboard/service/reports/report-order-dialog";
import { ReportPrintDialog } from "../../../../components/dashboard/service/reports/report-print-dialog";
import { ReportSendDialog } from "../../../../components/dashboard/service/reports/report-send-dialog";
import {
  CopyToClipboard,
  TWclassNames,
} from "../../../../components/utils/Div";
import HistoriesModal from "../../../../components/dashboard/histories/modal";
import { useUserHasAccess } from "../../../../routes/roleOnly";
import { ReportCopyModal } from "../../../../components/dashboard/service/reports/report-copy-moda";
import {
  mapsServiceUrl,
  serviceAgreementPath,
  stripHtml,
} from "../../../../components/Utils";
import { ReportExecutiveDialog } from "../../../../components/dashboard/service/reports/report-executive";
import { MentionsSection } from "../../../../components/dashboard/module_tags/mentionsSection";
import { ReportCorrectionSection } from "../../../../components/dashboard/service/reports/report-correction-section";
import { ReportApprovalSection } from "../../../../components/dashboard/service/reports/report-approval-section";
import { ReportAnalyzerSection, reportAnalyzerIsActive } from "../../../../components/dashboard/service/reports/report-analyzer-section";
import { NotesSection } from "../../../../components/dashboard/notes/notesSection";
import { CustomerSystemSection } from "../../../../components/dashboard/customers/systems/customerSystemSection";
import { ServiceReportTypeConditionsDialog } from "../../../../components/dashboard/service/settings/service-report-type-conditions-dialog";
import { useSelector } from "react-redux";
import { CommuncationsSection } from "../../../../components/dashboard/communcations/communcationsSection";
import { LabelDesignerDialog } from "../../../../components/labels/LabelDesignerDialog";
import { reportRecord } from "../../../../components/labels/labelRecords";
import { TinyDocumentSection } from "../../../../components/dashboard/documents/tinyDocumentSection";
import { TimeRegistrationSection } from "../../../../components/dashboard/hours/time-registration-section";
import { ReportSectionDialog } from "../../../../components/dashboard/service/reports/report-section-dialog";
import { ReportChecklistDialog } from "../../../../components/dashboard/service/reports/report-checklist-dialog";
import { ReportMobileNav } from "../../../../components/dashboard/service/reports/report-mobile-nav";
import { DocumentManagerV6 } from "../../../../components/dashboard/Media/DocumentManagerV6";
import { DirectImageUploadButton } from "../../../../components/dashboard/Media/DirectImageUploadButton";
import ReportFinishDialog from "../../../../components/dashboard/service/reports/report-finish-dialog";
import { ContactSection } from "../../../../components/dashboard/projects/ContactSection";
import { ReportAdditionalWorkCalculator } from "../../../../components/dashboard/service/reports/report-additional-work-calculator";
import {
  useServiceReportFinancialSummary,
} from "../../../../components/dashboard/service/reports/report-summary-section";
import { ReportAdminMenu } from "../../../../components/dashboard/service/reports/report-admin-menu";
import { ReportDevMenu } from "../../../../components/dashboard/service/reports/report-dev-menu";
import {
  ReportEditDrawer,
  ReportEditMenu,
  ReportEditFabs,
} from "../../../../components/dashboard/service/reports/report-edit-drawer";
import {
  ReportOppdragCard,
  ReportFinalizeCard,
  ReportPriceCard,
  ReportDeliveryAddressCard,
  ReportEconomyCard,
  ReportModuleCard,
  ReportLeadSummary,
  ReportHeader,
} from "../../../../components/dashboard/service/reports/report-view-redesign";
import ReportPreviousWork from "../../../../components/dashboard/service/reports/report-previous-work";
import ReportActiveAgreementChip from "../../../../components/dashboard/service/reports/report-active-agreement-chip";
import "./report-view-v2.css";
import { PMDialog } from "../../../../components/utils/PMDialog";
import ReportGuideOnboardingDialog from "../../../../components/dashboard/service/reports/ReportGuideOnboardingDialog";
import ReportGuideHistoryDialog from "../../../../components/dashboard/service/reports/ReportGuideHistoryDialog";
import {
  createReportGuideRun,
  fetchReportGuideRuns,
  fetchReportGuideTemplates,
} from "../../../../api/reportGuides";
import { excludingPromangStockReportGuideTemplates } from "../../../../utils/promangStockReportGuide";
import {
  reportVariablesPagePath,
  shouldOpenLegacyVariablesDialog,
} from "../../../../utils/reportVariablesUi";

export const ReportViewV2 = () => {
  const { t } = useTranslation();
  const settings = useSelector((state) => state.session.currentUser.settings);
  const navigate = useNavigate();

  const { id } = useParams();

  const [itemState, setItemState] = useState({
    isLoading: true,
    error: false,
    errors: [],
    report: {},
  });


  const { report, isLoading, error, errors } = itemState;

  const reportVariablesHref = useMemo(
    () => (report?.id ? reportVariablesPagePath(report.id) : null),
    [report?.id]
  );

  const variablesOpenLegacyDialog = useMemo(
    () => shouldOpenLegacyVariablesDialog(report),
    [report?.created_at, report?.uses_legacy_variables]
  );

  const {
    summary: reportFinancialSummary,
    loading: reportFinancialSummaryLoading,
  } = useServiceReportFinancialSummary(id, report?.updated_at);

  
  const [checklist, setChecklist] = useState(null);

  const hasAdminAccess = useUserHasAccess({ role: "service", action: "reset" });

  // Always request edit rights so admin UI matches server CanCan for this
  // report (company admin may edit without being hovedutførende).
  const reportListFields = useMemo(
    () =>
      `*,item_list_product_status,contact.*,-trips,-text_messages,-activity_items,-items,checklist,user_can_edit_with_rights,user_can_edit,approved,not_approved,updated_after_process,process_note,approval_status,correction_items`,
    []
  );

  const reportListFieldsWithPdf = useMemo(
    () =>
      `*,item_list_product_status,contact.*,-trips,-text_messages,pdf_customer_report_url,-activity_items,-items,checklist,user_can_edit_with_rights,user_can_edit,approved,not_approved,updated_after_process,process_note,approval_status,correction_items`,
    []
  );

  // Helper function to fetch checklist
  // const loadChecklist = useCallback((reportId) => {
  //   if (!reportId) {
  //     setChecklist(null);
  //     return;
  //   }

  //   fetchReportChecklist(reportId, {
  //     fields: "id,title,description,status,is_items_editable,items.id,items.title,items.isApproved,items.isDeviation,items.description,items.row_order",
  //   })
  //     .then((checklistResponse) => {
  //       // Check if response has errors (from backend)
  //       if (checklistResponse?.errors) {
  //         // If 404 error, it means no checklist exists yet - that's fine
  //         if (checklistResponse.errors.some(err => err.includes("does not have a checklist") || err.includes("404"))) {
  //           setChecklist(null);
  //         } else {
  //           console.error("Error loading checklist:", checklistResponse.errors);
  //           setChecklist(null);
  //         }
  //         return;
  //       }
        
  //       // Response can be either response.data (from axios) or just data (from our wrapper)
  //       const checklistData = checklistResponse?.data || checklistResponse;
  //       if (checklistData && checklistData.id) {
  //         // Ensure items is always an array
  //         if (!checklistData.items || !Array.isArray(checklistData.items)) {
  //           checklistData.items = [];
  //         }
  //         console.log("Checklist loaded:", checklistData.id, "items:", checklistData.items?.length || 0);
  //         setChecklist(checklistData);
  //       } else {
  //         console.log("No checklist data found");
  //         setChecklist(null);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error loading checklist:", error);
  //       // If 404, it means no checklist exists yet - that's fine
  //       if (error?.response?.status === 404 || error?.status === 404) {
  //         setChecklist(null);
  //       } else {
  //         setChecklist(null);
  //       }
  //     });
  // }, []);

  // Helper function to get finish report progress using same method as report-finish-dialog.js
  const getFinishReportProgress = () => {
    const finishReportOperations =
      report?.operations?.filter((op) => op.name === "finish_report") || [];

    const completedOperations = finishReportOperations.filter(
      (op) => op.can_be_completed === true
    );

    return {
      completed: completedOperations.length,
      total: finishReportOperations.length,
      isComplete:
        completedOperations.length === finishReportOperations.length &&
        finishReportOperations.length > 0,
    };
  };

  const handleDocumentsChange = (documents) => {
    // Document count is now managed by DocumentManagerV6
    // This callback is kept for potential future use
  };

  const [documentsUploadRevision, setDocumentsUploadRevision] = useState(0);

  useEffect(() => {
    const onDocumentsUploaded = (event) => {
      const { module, moduleParam } = event.detail || {};
      if (module === "report" && String(moduleParam) === String(report?.id)) {
        setDocumentsUploadRevision((n) => n + 1);
      }
    };
    window.addEventListener("promang:documents-uploaded", onDocumentsUploaded);
    return () =>
      window.removeEventListener("promang:documents-uploaded", onDocumentsUploaded);
  }, [report?.id]);

  const refreshTimeout = useRef();

  useEffect(() => {
    if (!id) return;

    // Reset state when id changes
    setItemState((prevState) => ({
      ...prevState,
      isLoading: true,
      error: false,
      errors: [],
      report: {},
    }));

    const params = {
      fields: reportListFields,
    };

    // Fetch report
    fetchReport(id, params)
      .then((response) => {
        // Check if response contains errors (even with 200 status)
        const data = response?.data || response;
        
        if (data?.errors && Array.isArray(data.errors) && data.errors.length > 0) {
          // Response has errors array - treat as error
          console.log('report errors in response', data.errors);
          toast.error(data.errors[0] || "Something went wrong when trying to load the report");
          setItemState((prevState) => ({
            ...prevState,
            isLoading: false,
            error: true,
            errors: data.errors,
          }));
          return;
        }
        
        if (data?.error) {
          // Response has error field - treat as error
          const errorMessage = Array.isArray(data.error) ? data.error : [data.error];
          console.log('report error in response', errorMessage);
          toast.error(errorMessage[0] || "Something went wrong when trying to load the report");
          setItemState((prevState) => ({
            ...prevState,
            isLoading: false,
            error: true,
            errors: errorMessage,
          }));
          
          return;
        }

        // Success - set report data
        setItemState((prevState) => ({
          ...prevState,
          isLoading: false,
          report: data?.data || data,

        }));

        setChecklist(data?.data?.checklist || data?.checklist || null);


        // Checklist will be loaded by useEffect when report.checklist_id is available
      })
      .catch((err) => {
        console.log('report catch error', err);
        const errorMessage = err?.errors
          ? (Array.isArray(err.errors) ? err.errors : [err.errors])
          : err?.response?.data?.errors 
          ? (Array.isArray(err.response.data.errors) ? err.response.data.errors : [err.response.data.errors])
          : err?.response?.data?.error
          ? (Array.isArray(err.response.data.error) ? err.response.data.error : [err.response.data.error])
          : err?.error
          ? (Array.isArray(err.error) ? err.error : [err.error])
          : err?.message
          ? [err.message]
          : ["Noe gikk galt ved lasting av rapport"];

        console.log('errorMessage', errorMessage);
        
        toast.error(errorMessage[0] || "Something went wrong when trying to load the report");
        setItemState((prevState) => ({
          ...prevState,
          isLoading: false,
          error: true,
          errors: errorMessage,
        }));
      });

    // Cleanup function to clear timeout when component unmounts or id changes
    return () => {
      if (refreshTimeout.current) {
        clearTimeout(refreshTimeout.current);
      }
    };
  }, [id, reportListFields]);

  // // Load checklist when report changes and has checklist.id
  // useEffect(() => {
  //   const checklistId = report?.checklist?.id;
  //   if (report?.id && checklistId) {
  //     // Only load if we don't have checklist or if checklist ID changed
  //     if (!checklist || checklist.id !== checklistId) {
  //       console.log("Loading checklist for report:", report.id, "checklist.id:", checklistId);
  //       loadChecklist(report.id);
  //     }
  //   } else if (report?.id && !checklistId) {
  //     // Clear checklist if report doesn't have checklist.id
  //     console.log("Report has no checklist.id, clearing checklist");
  //     setChecklist(null);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [report?.id, report?.checklist?.id]);

  const handleOnRefresh = useCallback((data) => {
    clearTimeout(refreshTimeout.current);

    if (!data || typeof data !== "object" || !("id" in data)) {
      return;
    }

    let didApply = false;
    setItemState((prevState) => {
      if (data.id !== prevState.report?.id) {
        return prevState;
      }

      const prev = prevState.report;
      const prevAt = prev?.updated_at ? Date.parse(prev.updated_at) : NaN;
      const incAt = data.updated_at ? Date.parse(data.updated_at) : NaN;
      const incomingIsOlder =
        Number.isFinite(prevAt) &&
        Number.isFinite(incAt) &&
        incAt < prevAt;
      const keepRichText =
        incomingIsOlder &&
        (data.report !== undefined || data.internal_report !== undefined);

      const updatedReport = {
        ...prev,
        ...data,
        items: data.items !== undefined ? data.items : prev?.items,
        items_summary:
          data.items_summary !== undefined ? data.items_summary : prev?.items_summary,
        variables:
          data.variables !== undefined ? data.variables : prev?.variables,
        checklist:
          data.checklist !== undefined ? data.checklist : prev?.checklist,
        report: keepRichText
          ? prev?.report
          : data.report !== undefined
            ? data.report
            : prev?.report,
        internal_report: keepRichText
          ? prev?.internal_report
          : data.internal_report !== undefined
            ? data.internal_report
            : prev?.internal_report,
        operations: data.operations || prev?.operations,
        updated_at: keepRichText
          ? prev?.updated_at
          : data.updated_at || prev?.updated_at,
        approved: data.approved !== undefined ? data.approved : prev?.approved,
        not_approved:
          data.not_approved !== undefined ? data.not_approved : prev?.not_approved,
        updated_after_process:
          data.updated_after_process !== undefined
            ? data.updated_after_process
            : prev?.updated_after_process,
        process_note:
          data.process_note !== undefined ? data.process_note : prev?.process_note,
        approval_status: data.approval_status || prev?.approval_status,
        correction_items:
          data.correction_items !== undefined
            ? data.correction_items
            : prev?.correction_items,
        additional_work_calculator_data:
          data.additional_work_calculator_data !== undefined
            ? data.additional_work_calculator_data
            : prev?.additional_work_calculator_data,
        item_list_product_status:
          data.item_list_product_status !== undefined
            ? data.item_list_product_status
            : prev?.item_list_product_status,
        participants:
          data.participants !== undefined ? data.participants : prev?.participants,
      };

      didApply = true;
      return {
        ...prevState,
        report: updatedReport,
      };
    });

    if (didApply) {
      setReportVersion((v) => v + 1);
    }
  }, []);

  const prepareRemoteRefresh = async () => {
    const fresh = await loadRecordSnapshot("report", report.id, { fields: reportListFields });
    return { apply: () => { handleOnRefresh(fresh); setChecklist(fresh.checklist || null); } };
  };

  const handleParticipantsChange = useCallback((list) => {
    setItemState((prev) => ({
      ...prev,
      report: prev.report?.id
        ? { ...prev.report, participants: list }
        : prev.report,
    }));
  }, []);

  const canEditReportContent = useMemo(() => {
    if (hasAdminAccess) return true;
    // Prefer server rights (admin / utførende / field editor). Do not let the
    // finished-only user_can_edit flag reopen edit for bystanders.
    if (report?.user_can_edit_with_rights === true) return true;
    if (report?.user_can_edit_with_rights === false) return false;
    return report?.user_can_edit !== false;
  }, [hasAdminAccess, report?.user_can_edit_with_rights, report?.user_can_edit]);

  // Memoize the report object to prevent unnecessary re-renders
  const memoizedReport = useMemo(() => {
    return report;
  }, [
    report?.id,
    report?.updated_at,
    report?.report,
    report?.internal_report,
    report?.variables?.length,
    JSON.stringify(report?.items_summary),
    report?.checklist?.id, // Only track if checklist exists, not full checklist data



    // Add dependency on variables content to detect changes
    
    JSON.stringify(
      report?.checklist?.items?.map((v) => ({
        id: v.id,
        isDeviation: v.isDeviation,
        isApproved: v.isApproved,
        is_not_applicable: v.is_not_applicable,
        response_code: v.response_code,
        note: v.note,
        checklist_type_id: v.checklist_type_id,
        title: v.title,
        description: v.description,
      }))
    ),
    JSON.stringify(
      report?.variables?.map((v) => ({
        id: v.id,
        reference: v.reference,
        field1: v.field1,
        field2: v.field2,
        field3: v.field3,
        field4: v.field4,
        note: v.note,
        unit_id: v.unit_id,
        variable_type_id: v.variable_type_id,
        delete: v.delete,
      }))
    ),
    JSON.stringify(report?.additional_work_calculator_data),
    // Checklist items are now loaded separately, so we only track if checklist exists
  ]);

  // Memoize the report ID to prevent unnecessary re-renders of NotesSection
  const reportId = useMemo(() => report?.id, [report?.id]);

  // Memoize contact ID to prevent unnecessary re-renders of ContactSection
  // Extract the ID value directly to avoid re-renders when contact object reference changes
  const contactId = useMemo(() => {
    return report?.contact?.id ?? null;
  }, [report?.contact?.id]);

  const reportSectionContentPreview = useMemo(() => {
    const plain = stripHtml(report?.report || "").trim();
    if (!plain) return "";
    return plain.length > 160 ? `${plain.slice(0, 159)}…` : plain;
  }, [report?.report]);

  const [editDrawerOpen, setEditDrawerOpen] = useState(false);
  const [editDrawerSection, setEditDrawerSection] = useState("info");
  const openEditDrawer = useCallback((section = "info") => {
    setEditDrawerSection(section || "info");
    setEditDrawerOpen(true);
  }, []);
  const [reportResetDialogOpen, setReportResetDialogOpen] = useState(false);
  const [reportExecutiveDialogOpen, setReportExecutiveDialogOpen] =
    useState(false);
  const [reportOrderDialogOpen, setReportOrderDialogOpen] = useState(false);
  const [reportPrintDialogOpen, setReportPrintDialogOpen] = useState(false);
  const [reportSendDialogOpen, setReportSendDialogOpen] = useState(false);
  const [reportCopyDialogOpen, setReportCopyDialogOpen] = useState(false);
  const [labelPrintDialogOpen, setLabelPrintDialogOpen] = useState(false);
  const [sectionDialogOpen, setSectionDialogOpen] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [checklistDialogOpen, setChecklistDialogOpen] = useState(false);
  const [processDialogRequest, setProcessDialogRequest] = useState(0);
  const [isAnalyzerRunning, setIsAnalyzerRunning] = useState(false);
  const [reportFinishDialogOpen, setReportFinishDialogOpen] = useState(false);
  const [reportVersion, setReportVersion] = useState(0);
  const [calculatorDialogOpen, setCalculatorDialogOpen] = useState(false);
  const [headerHistoriesOpen, setHeaderHistoriesOpen] = useState(false);
  const [headerCommunicationsOpen, setHeaderCommunicationsOpen] =
    useState(false);
  const [timeRegistrationDialogSignal, setTimeRegistrationDialogSignal] =
    useState(0);
  const [reportGuideTemplates, setReportGuideTemplates] = useState([]);
  const [reportGuideState, setReportGuideState] = useState({
    open: false,
    template: null,
    isSaving: false,
  });
  const [reportGuideChooserState, setReportGuideChooserState] = useState({
    open: false,
    templates: [],
  });
  const [reportGuideRuns, setReportGuideRuns] = useState([]);
  const [reportGuideHistoryOpen, setReportGuideHistoryOpen] = useState(false);

  // Close overlays when switching reports. ReportViewV2 is reused for
  // /reports/:id — an open write dialog over a new report stacks the full
  // view with the editor and keeps a stale edit_version.
  useEffect(() => {
    setEditDrawerOpen(false);
    setSectionDialogOpen(false);
    setSelectedSection(null);
    setChecklistDialogOpen(false);
    setReportResetDialogOpen(false);
    setReportExecutiveDialogOpen(false);
    setReportOrderDialogOpen(false);
    setReportPrintDialogOpen(false);
    setReportSendDialogOpen(false);
    setReportCopyDialogOpen(false);
    setLabelPrintDialogOpen(false);
    setReportFinishDialogOpen(false);
    setCalculatorDialogOpen(false);
    setReportGuideState({ open: false, template: null, isSaving: false });
    setReportGuideChooserState({ open: false, templates: [] });
    setReportGuideHistoryOpen(false);
    setHeaderHistoriesOpen(false);
    setHeaderCommunicationsOpen(false);
  }, [id]);

  useEffect(() => {
    const reportTypeId = report?.report_type?.id || report?.report_type_id || report?.report_type;
    if (!report?.id || !reportTypeId) return;

    let mounted = true;
    fetchReportGuideTemplates({
      report_type_id: reportTypeId,
      purpose: "field_report",
    })
      .then((templates) => {
        if (!mounted) return;
        const availableTemplates = excludingPromangStockReportGuideTemplates(
          Array.isArray(templates) ? templates.filter((template) => template?.id) : []
        );
        setReportGuideTemplates(availableTemplates);
      })
      .catch(() => setReportGuideTemplates([]));

    return () => {
      mounted = false;
    };
  }, [report?.id, report?.report_type?.id, report?.report_type_id, report?.report_type]);

  useEffect(() => {
    if (!report?.id) {
      setReportGuideRuns([]);
      return;
    }

    let mounted = true;
    fetchReportGuideRuns(report.id).then((runs) => {
      if (!mounted) return;
      setReportGuideRuns(Array.isArray(runs) ? runs : []);
    });

    return () => {
      mounted = false;
    };
  }, [report?.id, report?.updated_at]);

  const showReportGuideSection = useMemo(
    () => reportGuideTemplates.length > 0 || reportGuideRuns.length > 0,
    [reportGuideTemplates.length, reportGuideRuns.length]
  );

  function startReportGuide(template) {
    if (!template?.id) return;
    setReportGuideState({
      open: true,
      template,
      isSaving: false,
    });
  }

  function closeReportGuide() {
    setReportGuideState({
      open: false,
      template: null,
      isSaving: false,
    });
  }

  function openReportGuideChooser() {
    if (reportGuideTemplates.length === 0) {
      toast.error(t("Ingen rapportguide er tilgjengelig"));
      return;
    }
    if (reportGuideTemplates.length === 1) {
      startReportGuide(reportGuideTemplates[0]);
      return;
    }
    setReportGuideChooserState({ open: true, templates: reportGuideTemplates });
  }

  function closeReportGuideChooser() {
    setReportGuideChooserState({ open: false, templates: [] });
  }

  function openGuideEntryPoint() {
    if (reportGuideTemplates.length > 0) {
      openReportGuideChooser();
      return;
    }
    setReportGuideHistoryOpen(true);
  }

  async function completeReportGuide(guideRun) {
    if (!report?.id) return;

    setReportGuideState((state) => ({ ...state, isSaving: true }));
    const response = await createReportGuideRun(report.id, {
      report_guide_template_id: guideRun.report_guide_template_id,
      purpose: guideRun.purpose,
      answers: guideRun.answers,
      requested_from_customer: false,
    });

    if (response?.errors) {
      toast.error(Array.isArray(response.errors) ? response.errors.join(", ") : String(response.errors));
      setReportGuideState((state) => ({ ...state, isSaving: false }));
      return;
    }

    toast.success(t("Rapportguide lagret"));
    closeReportGuide();
    handleOnRefresh(response?.report || response?.data);
    fetchReportGuideRuns(report.id).then((runs) => {
      setReportGuideRuns(Array.isArray(runs) ? runs : []);
    });
  }

  const summaryItems = useMemo(() => {
    const customer = report?.customer;
    const customerId = customer?.id;
    const customerPath = customerId
      ? `/dashboard/customers/${customerId}`
      : null;
    const titleText = customer?.displayTitle || "—";

    const customerValue = (
      <div className="space-y-1.5">
        <div>
          {customerPath ? (
            <Link
              to={customerPath}
              className="text-blue-600 hover:text-blue-800 hover:underline"
            >
              {titleText}
            </Link>
          ) : (
            titleText
          )}
        </div>
        {(customer?.mobile || customer?.email) && (
          <div className="space-y-1 text-xs font-normal text-gray-600">
            {customer?.mobile ? (
              <a
                href={`tel:${String(customer.mobile).replace(/\s/g, "")}`}
                className="flex min-w-0 items-start gap-1.5 break-all text-gray-600 hover:text-blue-700"
              >
                <PhoneIcon
                  className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gray-400"
                  aria-hidden
                />
                <span>{customer.mobile}</span>
              </a>
            ) : null}
            {customer?.email ? (
              <a
                href={`mailto:${customer.email}`}
                className="flex min-w-0 items-start gap-1.5 break-all text-gray-600 hover:text-blue-700"
              >
                <AtSymbolIcon
                  className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gray-400"
                  aria-hidden
                />
                <span>{customer.email}</span>
              </a>
            ) : null}
          </div>
        )}
      </div>
    );

    const assignees = (report?.participants || []).filter((p) => !p.delete);
    const executingValue = (
      <div className="rvp-exec">
        <span className="rvp-exec-main">
          {report?.executing_employee?.name || "-"}
        </span>
        {assignees.length > 0 && (
          <span className="rvp-exec-badges">
            {assignees.map((p) => (
              <span key={p.id} className="rvp-exec-badge">
                {p.displayTitle || p.user?.displayTitle || "—"}
              </span>
            ))}
          </span>
        )}
      </div>
    );

    return [
      {
        label: t("report.view.summary.customer"),
        value: customerValue,
        path: null,
      },
      {
        label: "Prosjekt",
        value: report?.project?.displayTitle || "-",
        path: report?.project?.id
          ? `/dashboard/projects/${report.project.id}`
          : null,
        hidden: !report?.project?.id,
      },
      {
        label: "Utførende",
        value: executingValue,
      },
      {
        label: "Rapporttype",
        value: report?.report_type?.displayTitle || "-",
      },
    ];
  }, [
    report?.customer,
    report?.project,
    report?.executing_employee,
    report?.report_type,
    report?.participants,
    t,
  ]);

  const headerActions = [
    {
      component: null,
      label: t("histories.title"),
      description: "",
      path: null,
      action: () => setHeaderHistoriesOpen(true),
      icon: ClockIcon,
      textColor: "text-teal-700",
      bgColor: "bg-white",
      hidden: !hasAdminAccess,
      menu: true,
    },
    {
      component: null,
      label: t("Communication"),
      description: "",
      path: null,
      action: () => setHeaderCommunicationsOpen(true),
      icon: RectangleGroupIcon,
      textColor: "text-teal-700",
      bgColor: "bg-white",
      hidden: !hasAdminAccess || !report?.customer?.id,
      menu: true,
    },

    {
      component: null,
      label: "Utførende",
      description: "",
      path: null,
      action: () => setReportExecutiveDialogOpen(true),
      icon: UserIcon,
      textColor: "text-teal-700",
      bgColor: "bg-white",
      hidden: hasAdminAccess ? false : true,
      menu: true,
    },
    {
      component: null,
      label: "Reset",
      description: "",
      path: null,
      action: () => setReportResetDialogOpen(true),
      icon: ArrowPathRoundedSquareIcon,
      textColor: "text-teal-700",
      bgColor: "bg-white",
      hidden: hasAdminAccess ? false : true,
      menu: true,
    },
    {
      component: null,
      label: "Order",
      description: "",
      path: null,
      action: () => setReportOrderDialogOpen(true),
      icon: ClipboardDocumentListIcon,
      textColor: "text-teal-700",
      bgColor: "bg-white",
      hidden: report?.finished ? false : true,
      menu: true,
    },
    {
      component: null,
      label: "Copy",
      description: "",
      path: null,
      action: () => setReportCopyDialogOpen(true),
      icon: ClipboardDocumentCheckIcon,
      textColor: "text-teal-700",
      bgColor: "bg-white",
      hidden: false,
      menu: true,
    },
    {
      component: null,
      label: "Skriv ut",
      description: "",
      path: null,
      action: () => setReportPrintDialogOpen(true),
      icon: PrinterIcon,
      textColor: "text-teal-700",
      bgColor: "bg-white",
      hidden: false,
      menu: true,
    },
    {
      component: null,
      label: "Last ned kunderapport",
      description: "",
      path: null,
      action: () => {
        if (report?.pdf_customer_report_url) {
          window.open(report.pdf_customer_report_url, "_blank");
        } else {
          toast.error("Kunderapport PDF er ikke tilgjengelig. Generer den via 'Skriv ut'.");
        }
      },
      icon: ClipboardDocumentCheckIcon,
      textColor: "text-teal-700",
      bgColor: "bg-white",
      hidden: !report?.pdf_customer_report_url || !report?.approved,
      menu: true,
    },
    {
      component: null,
      label: "Send",
      description: "",
      path: null,
      action: () => setReportSendDialogOpen(true),
      icon: AtSymbolIcon,
      textColor: "text-teal-700",
      bgColor: "bg-white",
      hidden: false,
      menu: true,
    },
    {
      component: null,
      label: t("report.view.mobileNav.guide"),
      description: "",
      path: null,
      action: openGuideEntryPoint,
      icon: SparklesIcon,
      textColor: "text-sky-700",
      bgColor: "bg-white",
      hidden: !showReportGuideSection,
      menu: true,
    },
    {
      component: null,
      label: "Kalkyle",
      description: "",
      path: null,
      action: () => setCalculatorDialogOpen(true),
      icon: CalculatorIcon,
      textColor: "text-teal-700",
      bgColor: "bg-white",
      hidden: false,
      menu: true,
    },
    {
      component: null,
      label: "Print Label",
      description: "",
      path: null,
      action: () => setLabelPrintDialogOpen(true),
      icon: PrinterIcon,
      textColor: "text-black",
      bgColor: "bg-white",
      hidden: false,
      menu: true,
    },
  ];

  // Header "Rediger informasjon ▾" dropdown (primary edit entry point).
  const editMenuAction = {
    component: <ReportEditMenu onSelect={openEditDrawer} />,
    hidden: !canEditReportContent,
    menu: false,
  };

  // Actions surfaced inside the mobile "Meny" floating button bottom-sheet.
  const editMobileActions = headerActions
    .filter((a) => a.hidden === false && !a.component)
    .map((a) => ({ label: a.label, icon: a.icon, action: a.action }));

  const [reportTypeDialogOpen, setReportTypeDialogOpen] = useState(false);

  const handleRetry = useCallback(() => {
    if (!id) return;
    
    setItemState((prevState) => ({
      ...prevState,
      isLoading: true,
      error: false,
      errors: [],
    }));

    const params = {
      fields: reportListFieldsWithPdf,
    };

    fetchReport(id, params)
      .then((response) => {
        const data = response?.data || response;
        
        if (data?.errors && Array.isArray(data.errors) && data.errors.length > 0) {
          toast.error(data.errors[0] || "Something went wrong when trying to load the report");
          setItemState((prevState) => ({
            ...prevState,
            isLoading: false,
            error: true,
            errors: data.errors,
          }));
          return;
        }
        
        if (data?.error) {
          const errorMessage = Array.isArray(data.error) ? data.error : [data.error];
          toast.error(errorMessage[0] || "Something went wrong when trying to load the report");
          setItemState((prevState) => ({
            ...prevState,
            isLoading: false,
            error: true,
            errors: errorMessage,
          }));
          return;
        }

        setItemState((prevState) => ({
          ...prevState,
          isLoading: false,
          report: data?.data || data,
        }));
      })
      .catch((err) => {
        const errorMessage = err?.errors
          ? (Array.isArray(err.errors) ? err.errors : [err.errors])
          : err?.response?.data?.errors 
          ? (Array.isArray(err.response.data.errors) ? err.response.data.errors : [err.response.data.errors])
          : err?.response?.data?.error
          ? (Array.isArray(err.response.data.error) ? err.response.data.error : [err.response.data.error])
          : err?.error
          ? (Array.isArray(err.error) ? err.error : [err.error])
          : err?.message
          ? [err.message]
          : ["Noe gikk galt ved lasting av rapport"];

        toast.error(errorMessage[0] || "Something went wrong when trying to load the report");
        setItemState((prevState) => ({
          ...prevState,
          isLoading: false,
          error: true,
          errors: errorMessage,
        }));
      });
  }, [id, reportListFieldsWithPdf]);

  if (isLoading) {
    return (
      <DashboardHeader variant="v2" title="Rapport">
        <ResourceLoading />
      </DashboardHeader>
    );
  }

  if (error) {
    return (
      <DashboardHeader variant="v2" title="Rapport">
        <ResourceError errors={errors} onRetry={handleRetry} retryLabel="Last inn på nytt" />
      </DashboardHeader>
    );
  }

  if (!report?.id) {
    return (
      <DashboardHeader variant="v2" title="Rapport">
        <ResourceEmpty />
      </DashboardHeader>
    );
  }

  const analyzerActive = reportAnalyzerIsActive(report, isAnalyzerRunning);

  const reportContent = (
    <>
      <div className="rvp-scope">
        <div className="mx-auto max-w-7xl px-4 py-5 pb-[calc(5rem+env(safe-area-inset-bottom,0px))] lg:pb-5">
          <div className="rvp-grid">
            <div className="rvp-stack">
            <div className="flex flex-wrap items-center gap-2">
              <ReportActiveAgreementChip report={report} />
            </div>
            <ReportLeadSummary items={summaryItems} />
            <ReportPreviousWork report={report} />

            {report?.not_approved && (
              <ReportCorrectionSection report={report} />
            )}

            {report?.finished && !report?.deleted && (
              <div className="rvp-embed-card">
                <ReportAnalyzerSection
                  report={report}
                  onRefresh={handleOnRefresh}
                  onRequestProcess={() => setProcessDialogRequest((value) => value + 1)}
                  onRunningChange={setIsAnalyzerRunning}
                />
              </div>
            )}

            {report?.finished && !report?.deleted && (
              analyzerActive ? (
                <ReportApprovalSection
                  report={report}
                  onRefresh={handleOnRefresh}
                  openProcessTrigger={processDialogRequest}
                  hideCard
                />
              ) : (
                <div className="rvp-embed-card">
                  <ReportApprovalSection
                    report={report}
                    onRefresh={handleOnRefresh}
                    openProcessTrigger={processDialogRequest}
                  />
                </div>
              )
            )}

            {report?.report_type?.agreement && !report?.deleted && (
              <div className="rvp-embed-card">
                <ReportAgreement report={report} onRefresh={handleOnRefresh} />
              </div>
            )}

            {contactId && !report?.deleted && (
              <div className="rvp-embed-card">
                <ContactSection contactId={contactId} mini={true} />
              </div>
            )}

            {report?.report_type?.system && (
              <div className="rvp-embed-card">
                <CustomerSystemSection
                  system={report?.system}
                  customer={report?.customer}
                  module="report"
                  moduleParam={report?.id}
                  onRefresh={handleOnRefresh}
                  operations={report?.operations}
                />
              </div>
            )}
            <ReportDeliveryAddressCard report={report} />

            <ReportOppdragCard
              report={report}
              canEdit={canEditReportContent}
              onEdit={openEditDrawer}
              onReportTypeClick={() => setReportTypeDialogOpen(true)}
            >
              <div style={{ marginTop: 12 }}>
                <TinyDocumentSection
                  module="report_description"
                  moduleParam={report?.id}
                  refreshTrigger={reportVersion}
                />
              </div>
            </ReportOppdragCard>


            <ServiceReportTypeConditionsDialog
              open={reportTypeDialogOpen}
              onClose={() => setReportTypeDialogOpen(false)}
              reportType={report?.report_type}
            />

            <div className="rvp-embed-card">
              <NotesSection module="report" module_param={reportId} />
            </div>

            {/* Report Sections Cards — desktop only; mobile uses bottom nav */}
            {!report?.deleted && (
              <div className="col-span-5 lg:col-span-5 hidden lg:block">
                <div
                  className={`grid grid-cols-1 gap-6 ${(() => {
                    const activeModules = [
                      report?.report_type?.items,
                      report?.report_type?.variables,
                      report?.report_type?.checklist,
                      showReportGuideSection,
                      true, // report is always shown
                    ].filter(Boolean).length;

                    if (activeModules === 1)
                      return "sm:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1";
                    if (activeModules === 2)
                      return "sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2";
                    if (activeModules === 3)
                      return "sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3";
                    if (activeModules === 4)
                      return "sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-4";
                    return "sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5";
                  })()}`}
                >
                  {/* Item Consumption Card */}
                  {report?.report_type?.items && (() => {
                    const orderLinesStatus = ServiceReportOperationObjectStatus({
                      operations: report?.operations,
                      objectName: "order_lines",
                    });
                    const itemConsumptionStatus = ServiceReportOperationObjectStatus({
                      operations: report?.operations,
                      objectName: "item_consumption",
                    });
                    
                    // Check item_consumption status first (takes priority)
                    let statusText = "Mangler";
                    let isCompleted = false;
                    let isRequired = true;
                    
                    if (itemConsumptionStatus === "REQUIRED") {
                      // Item consumption not handled - blocks completion
                      statusText = "Mangler";
                      isCompleted = false;
                      isRequired = true;
                    } else if (itemConsumptionStatus === "FINISHED") {
                      // Item consumption handled - check order_lines status
                      if (orderLinesStatus === "FINISHED") {
                        statusText = "Ferdig";
                        isCompleted = true;
                        isRequired = true;
                      } else if (orderLinesStatus === "NOT_REQUIRED") {
                        statusText = "Ikke påkrevd";
                        isCompleted = true;
                        isRequired = false;
                      } else {
                        statusText = "Mangler";
                        isCompleted = false;
                        isRequired = true;
                      }
                    } else if (itemConsumptionStatus === "NOT_REQUIRED") {
                      // No item consumption operations - use order_lines status
                      if (orderLinesStatus === "FINISHED") {
                        statusText = "Ferdig";
                        isCompleted = true;
                        isRequired = true;
                      } else if (orderLinesStatus === "NOT_REQUIRED") {
                        statusText = "Ikke påkrevd";
                        isCompleted = true;
                        isRequired = false;
                      } else {
                        statusText = "Mangler";
                        isCompleted = false;
                        isRequired = true;
                      }
                    } else {
                      // Fallback to order_lines status
                      if (orderLinesStatus === "FINISHED") {
                        statusText = "Ferdig";
                        isCompleted = true;
                        isRequired = true;
                      } else if (orderLinesStatus === "NOT_REQUIRED") {
                        statusText = "Ikke påkrevd";
                        isCompleted = true;
                        isRequired = false;
                      } else {
                        statusText = "Mangler";
                        isCompleted = false;
                        isRequired = true;
                      }
                    }
                    
                    return (
                      <ReportModuleCard
                        title="Vareforbruk"
                        subtitle={t("report.redesign.module.items_sub")}
                        icon={CubeIcon}
                        accent="green"
                        count={
                          report?.items_summary?.count ??
                          report?.items?.filter((item) => !item.delete).length ??
                          0
                        }
                        complete={isCompleted}
                        notRequired={!isRequired}
                        canEdit={canEditReportContent}
                        to={`/dashboard/service/reports/${report?.id}/item-consumption`}
                      />
                    );
                  })()}

                  {/* Variables Card */}
                  {report?.report_type?.variables && (() => {
                    const variablesStatus = ServiceReportOperationObjectStatus({
                      operations: report?.operations,
                      objectName: "variables",
                    });
                    return (
                      <ReportModuleCard
                        title="Variabler"
                        subtitle={t("report.redesign.module.variables_sub")}
                        icon={VariableIcon}
                        accent="violet"
                        count={
                          report?.variables?.filter((variable) => !variable.delete)
                            .length || 0
                        }
                        complete={variablesStatus === "FINISHED"}
                        notRequired={variablesStatus === "NOT_REQUIRED"}
                        canEdit={canEditReportContent}
                        {...(variablesOpenLegacyDialog
                          ? {
                              onClick: () => {
                                setSelectedSection("variables");
                                setSectionDialogOpen(true);
                              },
                            }
                          : {
                              to:
                                reportVariablesHref ||
                                `/dashboard/service/reports/${report?.id}/variables`,
                            })}
                      />
                    );
                  })()}

                  {/* Checklist Card */}
                  {report?.report_type?.checklist && (() => {
                    // Report payload is refreshed after edits; local checklist state is only set on first load.
                    const checklistData = report?.checklist?.id
                      ? report.checklist
                      : checklist;
                    const checklistStatus = getChecklistStatus(checklistData);
                    
                    return (
                      <ReportModuleCard
                        title="Sjekkliste"
                        subtitle={t("report.redesign.module.checklist_sub")}
                        icon={ClipboardDocumentIcon}
                        accent="blue"
                        count={checklistStatus.completedCount}
                        total={checklistStatus.totalCount}
                        complete={checklistStatus.isCompleted}
                        notRequired={!checklistStatus.isRequired}
                        canEdit={canEditReportContent}
                        to={`/dashboard/service/reports/${report?.id}/checklist`}
                      />
                    );
                  })()}

                  {/* Report guides — desktop summary + history */}
                  {showReportGuideSection && (
                    <ReportModuleCard
                      title={t("report.view.sectionGuide.title")}
                      subtitle={t("report.redesign.module.guide_sub")}
                      icon={SparklesIcon}
                      accent="amber"
                      count={reportGuideRuns.length}
                      complete={reportGuideRuns.length > 0}
                      notRequired={false}
                      canEdit={canEditReportContent}
                      onClick={() => setReportGuideHistoryOpen(true)}
                    />
                  )}

                  {/* Report Content Card - Always shown */}
                  {(() => {
                    const reportStatus = ServiceReportOperationObjectStatus({
                      operations: report?.operations,
                      objectName: "report",
                    });
                    return (
                      <ReportModuleCard
                        title={t("report.view.sectionReport.title")}
                        subtitle={t("report.view.sectionReport.cardSubtitle")}
                        icon={ClipboardDocumentCheckIcon}
                        accent="teal"
                        count={report?.report ? 1 : 0}
                        total={1}
                        complete={reportStatus === "FINISHED"}
                        notRequired={reportStatus === "NOT_REQUIRED"}
                        canEdit={canEditReportContent}
                        onClick={() => {
                          setSelectedSection("report");
                          setSectionDialogOpen(true);
                        }}
                      />
                    );
                  })()}
                </div>
              </div>
            )}

            {/* Time Registration Section */}
            {!report?.deleted && (
              <div
                id="report-view-time-registration"
                className="col-span-5 lg:col-span-5 scroll-mt-20"
                data-section="time-registration"
              >
                <TimeRegistrationSection
                  module="report"
                  moduleId={reportId}
                  project={report?.project}
                  report={report}
                  onRefresh={handleOnRefresh}
                  title="Timeregistrering"
                  description="Registrer timer for denne rapporten"
                  openRegistrationDialogSignal={timeRegistrationDialogSignal}
                />
              </div>
            )}

            {/* Documents Section */}
            {!report?.deleted && (
              <div className="col-span-5 lg:col-span-5">
                <div className="flex flex-col gap-2 sm:flex-row sm:items-stretch">
                  {canEditReportContent && report?.id && (
                    <DirectImageUploadButton
                      module="report"
                      moduleParam={report.id}
                      size="large"
                      className="sm:flex-shrink-0"
                      previewOptions={
                        report?.project?.id
                          ? {
                              folderSupport: true,
                              folderProjectId: report.project.id,
                              drawingSupport: true,
                              project: report.project,
                            }
                          : undefined
                      }
                    />
                  )}
                  <div className="min-w-0 flex-1">
                    <DocumentManagerV6
                      key={`report-docs-${report?.id}-${documentsUploadRevision}`}
                      module="report"
                      moduleParam={report?.id}
                      project={report?.project}
                      folderSupport={Boolean(report?.project?.id)}
                      mode="dropzone"
                      maxDisplay={12}
                      showUpload={canEditReportContent}
                      showExisting={true}
                      allowDelete={canEditReportContent}
                      allowEdit={canEditReportContent}
                      allowCopy={canEditReportContent}
                      allowMove={canEditReportContent}
                      autoLoad={false}
                      onDocumentsChange={handleDocumentsChange}
                    />
                  </div>
                </div>
              </div>
            )}

            </div>

            <aside className="rvp-side">
              {!report?.deleted && (
                <ReportFinalizeCard
                  report={report}
                  progress={getFinishReportProgress()}
                  onFinish={() => setReportFinishDialogOpen(true)}
                />
              )}

              {(() => {
                const calcEntries =
                  report?.additional_work_calculator_data?.entries;
                const last =
                  Array.isArray(calcEntries) && calcEntries.length > 0
                    ? calcEntries[0]
                    : null;
                if (!last?.totals || report?.deleted) return null;
                return (
                  <ReportPriceCard
                    exVat={last.totals.customer_total_ex_vat}
                    incVat={last.totals.customer_total_inc_vat}
                    onOpen={() => setCalculatorDialogOpen(true)}
                  />
                );
              })()}

              {!report?.deleted && (
                <ReportAdminMenu
                  report={report}
                  isLoading={isLoading}
                  onRefresh={handleOnRefresh}
                  hideMobileFab
                />
              )}

              {hasAdminAccess && !report?.deleted && (
                <ReportEconomyCard
                  report={report}
                  summary={reportFinancialSummary}
                  loading={reportFinancialSummaryLoading}
                />
              )}

              <ReportDevMenu report={report} />
            </aside>
          </div>
        </div>
      </div>

          <ReportMobileNav
            report={report}
            reportVariablesHref={reportVariablesHref}
            showGuide={showReportGuideSection}
            onOpenGuide={openGuideEntryPoint}
            onOpenReport={() => {
              setSelectedSection("report");
              setSectionDialogOpen(true);
            }}
            onOpenTimeRegistration={() =>
              setTimeRegistrationDialogSignal((n) => n + 1)
            }
          />
        </>
  );

  return (
    <>
      <DashboardHeader
        variant="v2"
        sticky
        title={FullReportTitle(report)}
        customHeader={
          <ReportHeader
            report={report}
            title={FullReportTitle(report)}
            subtitle={report?.report_type?.displayTitle || ""}
            editMenu={editMenuAction.hidden ? null : editMenuAction.component}
            menuActions={headerActions}
            backTo="/dashboard/service/reports"
          />
        }
      >
        <RecordCollaborationPanel report={report} section={editDrawerOpen ? editDrawerSection : "overview"} visible={!editDrawerOpen && !(sectionDialogOpen && selectedSection === "report")}
          editing={sectionDialogOpen || checklistDialogOpen || reportResetDialogOpen || reportExecutiveDialogOpen || reportOrderDialogOpen || reportSendDialogOpen || reportCopyDialogOpen || reportFinishDialogOpen || calculatorDialogOpen || reportGuideState.open || isAnalyzerRunning}
          refreshBlocked={editDrawerOpen || sectionDialogOpen || checklistDialogOpen || reportResetDialogOpen || reportExecutiveDialogOpen || reportOrderDialogOpen || reportSendDialogOpen || reportCopyDialogOpen || reportFinishDialogOpen || calculatorDialogOpen || reportGuideState.open || isAnalyzerRunning}
          onRefresh={prepareRemoteRefresh} />
        {reportContent}
      </DashboardHeader>

      <ReportEditDrawer
        prepareRemoteRefresh={prepareRemoteRefresh}
        open={editDrawerOpen}
        section={editDrawerSection}
        report={memoizedReport}
        canEdit={canEditReportContent}
        onClose={() => setEditDrawerOpen(false)}
        onRefresh={handleOnRefresh}
        onParticipantsChange={handleParticipantsChange}
      />

      {!report?.deleted && (
        <ReportEditFabs
          onEdit={() => openEditDrawer("info")}
          actions={editMobileActions}
        />
      )}

      <HistoriesModal
        open={headerHistoriesOpen}
        onClose={() => setHeaderHistoriesOpen(false)}
        module="report"
        module_param={report?.id}
      />

      {hasAdminAccess && report?.customer?.id ? (
        <CommuncationsSection
          customer={report.customer}
          related_type="report"
          related_id={report?.id}
          type="button"
          renderTrigger={false}
          open={headerCommunicationsOpen}
          onOpenChange={setHeaderCommunicationsOpen}
        />
      ) : null}

      <ReportSendDialog
        report={memoizedReport}
        open={reportSendDialogOpen}
        isLoading={isLoading}
        onClose={() => setReportSendDialogOpen(false)}
        onRefresh={handleOnRefresh}
      />

      <ReportPrintDialog
        report={memoizedReport}
        open={reportPrintDialogOpen}
        isLoading={isLoading}
        onClose={() => setReportPrintDialogOpen(false)}
        onRefresh={handleOnRefresh}
      />

      <ReportResetDialog
        report={memoizedReport}
        open={reportResetDialogOpen}
        isLoading={isLoading}
        onClose={() => setReportResetDialogOpen(false)}
        onRefresh={handleOnRefresh}
      />

      <ReportExecutiveDialog
        report={memoizedReport}
        open={reportExecutiveDialogOpen}
        isLoading={isLoading}
        onClose={() => setReportExecutiveDialogOpen(false)}
        onRefresh={handleOnRefresh}
      />

      <ReportOrderDialog
        report={memoizedReport}
        open={reportOrderDialogOpen}
        isLoading={isLoading}
        onClose={() => setReportOrderDialogOpen(false)}
        onRefresh={handleOnRefresh}
      />

      <ReportCopyModal
        open={reportCopyDialogOpen}
        onClose={() => setReportCopyDialogOpen(false)}
        report={memoizedReport}
      />

      <LabelDesignerDialog
        module="report"
        open={labelPrintDialogOpen && !!report?.id}
        onClose={() => setLabelPrintDialogOpen(false)}
        loadRecords={() => [reportRecord(report)]}
      />

      <ReportSectionDialog
        open={sectionDialogOpen}
        onClose={() => {
          // If checklist dialog was open, refresh checklist status
          // if (selectedSection === "checklist" && report?.checklist?.id) {
          //   loadChecklist(report.id);
          // }
          
          setSectionDialogOpen(false);
          setSelectedSection(null);
        }}
        report={memoizedReport}
        section={selectedSection}
        onRefresh={handleOnRefresh}
      />

      <ReportChecklistDialog
        open={checklistDialogOpen}
        onClose={() => setChecklistDialogOpen(false)}
        report={memoizedReport}
        onRefresh={handleOnRefresh}
      />


      <ReportFinishDialog
        open={reportFinishDialogOpen}
        onClose={() => setReportFinishDialogOpen(false)}
        selected={memoizedReport}
        onRefresh={(data) => {
          console.log("data from FinishDialog", data);
          handleOnRefresh(data.data);
          setReportFinishDialogOpen(false);
        }}
        isLoading={isLoading}
      />

      <ReportAdditionalWorkCalculator
        report={memoizedReport}
        onRefresh={handleOnRefresh}
        open={calculatorDialogOpen}
        onClose={() => setCalculatorDialogOpen(false)}
        showSection={false}
      />

      <PMDialog
        open={reportGuideChooserState.open}
        onClose={closeReportGuideChooser}
        title={t("Velg rapportguide")}
        size="3xl"
      >
        <div className="space-y-3">
          <p className="text-sm text-slate-600">
            {t("Velg guiden som passer best med oppdraget.")}
          </p>
          {(reportGuideChooserState.templates || []).map((template) => (
            <button
              key={template.id}
              type="button"
              onClick={() => {
                closeReportGuideChooser();
                startReportGuide(template);
              }}
              className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-4 text-left transition hover:border-sky-300 hover:bg-sky-50"
            >
              <div className="text-sm font-semibold text-slate-950">
                {template.title || t("Rapportguide")}
              </div>
              {template.description ? (
                <div className="mt-1 text-sm text-slate-500">{template.description}</div>
              ) : null}
              <div className="mt-2 text-xs font-medium uppercase tracking-[0.18em] text-slate-400">
                {(template.questions || []).length} {t("spørsmål")}
              </div>
            </button>
          ))}
        </div>
      </PMDialog>

      <ReportGuideOnboardingDialog
        open={reportGuideState.open}
        template={reportGuideState.template}
        report={memoizedReport}
        isSaving={reportGuideState.isSaving}
        onClose={closeReportGuide}
        onComplete={completeReportGuide}
      />

      <ReportGuideHistoryDialog
        open={reportGuideHistoryOpen}
        onClose={() => setReportGuideHistoryOpen(false)}
        runs={reportGuideRuns}
        canStartMore={canEditReportContent && reportGuideTemplates.length > 0}
        onStartGuide={openReportGuideChooser}
      />
    </>
  );
};
